import { render, staticRenderFns } from "./FromNowSpan.vue?vue&type=template&id=06a73ba0&"
import script from "./FromNowSpan.vue?vue&type=script&lang=ts&"
export * from "./FromNowSpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports